

























import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import warehouseCity from '@/store/entities/warehouse-city';
import warehouseInfo from '@/store/entities/warehouseInfo';
import appconst from '@/lib/appconst';
import Enums from '@/lib/enums'
class AddBaseCost {
    id: number;
    shelfPosition: string;
}
@Component
export default class CreateBaseCostModule extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    storecost: AddBaseCost = new AddBaseCost();
    addLoding = false;
    isDisplay: boolean;
    shelf: string = "";
    created() {
        this.enterSearch();
    }
    signFor() {
        this.save();
    }
    //回车搜索
    enterSearch() {
        var _this = this;
        document.onkeydown = e => {
            //13表示回车键，baseURI是当前页面的地址，为了更严谨，也可以加别的，可以打印e看一下
            if (e.keyCode === 13 && _this.isDisplay) {
                //回车后执行搜索方法
                this.save();
            }
        }
    }
    save() {
        (this.$refs.settingcostForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.storecost.id = this.$store.state.backstock.id;
                this.addLoding = true;
                await this.$store.dispatch({
                    type: 'backstock/ShelfUp',
                    data: this.storecost
                }).finally(() => {
                    this.addLoding = false;
                });
                (this.$refs.settingcostForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input', false);
                if (this.$store.state.backstock.automaticJump) {
                    var timestamp1 = (new Date()).valueOf().toString();
                    this.$router.push({ name: this.$store.state.backstock.automaticPath, params: { StockJumpPage: timestamp1 } });
                }

            }
        })
    }


    cancel() {
        (this.$refs.settingcostForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        this.isDisplay = value;
        if (!value) {
            this.$emit('input', value);
        } else {
            this.$set(this.storecost, "shelfPosition","");
            this.check();

            var shelfPositionInput = this.$refs.shelfPositionInput as any;
            this.$nextTick(() => {
                shelfPositionInput.focus();
            });
        }
    }
    async check() {
        this.shelf = await this.$store.dispatch({
            type: 'backstock/CheckShelf',
            data: { id: this.$store.state.backstock.id}
        })
        if (this.shelf) {
            this.$set(this.storecost, "shelfPosition", this.shelf);
        }
    }
    costRule = {
        shelfPosition: [
            { required: true, message: '货架号不能为空', trigger: 'blur' }
        ],

    };

}
